<!-- App header added here -->
<app-head></app-head>
<div class="content" style="display: none;"><span>ctl-sm-portal app is running!</span> </div> 
<router-outlet *ngIf="this.route !== 'dashboard'"></router-outlet>
<main *ngIf="this.route === 'dashboard'" [dir]="textDir">
  <aside class="syspanel hidden" [dir]="textDir"></aside>
  <div class="app slide-right">
    <div class="appbody" style="margin-bottom: 48px;">
      <div class="appnav" >
        <div class="actions-left" style="padding-left: 20px;padding-right: 10px;margin-top: 50px;">
          <span class="item"><label class="elabel" style="font-size: 18px;" >{{'Filters' | translate}}</label></span>
          <hr>
          <span class="item"><p><label class="elabel" style="color: #ffffff;opacity:0.6;">{{'Time Period' | translate}}</label></p></span>
          <span class="item light">
             <div class="select" data-type="single" [dir]="textDir">
              <button class="btn current-options" style="width:200px;height:28px;background-color: #ffffff;color: #181818;" *ngIf="selectedTimePeriodStr !=''" >{{selectedTimePeriodStr}}</button>
              <div class="options-list" >
                <div class="item" *ngFor="let item of timePeriodArr;" (click)="selectTimePeriod(item?.id,item?.name)" >{{item?.name}}</div>
              </div>
            </div>
           <!--  <div class="custom-select">
            <select name="timeperiod" id="styledSelect" [dir]="textDir" [(ngModel)] = "selectedTimePeriodStr">
              <option *ngFor="let item of timePeriodArr;"  (click)="selectTimePeriod(item?.id,item?.name)">{{item?.name}}</option>             
            </select>
          </div> -->
            <!-- <div #timeperiod class="dropdown" data-type="click" style="width:220px;">
              <button class="btn clickable">Select option</button>
              <div #listMenu class="menu">
               
                <div class="item" *ngFor="let item of timePeriodArr;" (click)="selectTimePeriod(item?.id)">{{item?.name}}</div>
              </div>
            </div> -->
            
          </span>
          <div [hidden]="!isSecificDateVisible">
            <span class="item"><h4 class="elabel">From</h4></span>
            <span class="item light">        
              <div class="datepickerFrom">
                <input id="datepickerFrom" type="text" placeholder="YYYY-MM-DD" name="datepicker" class="with-icon" style="width:200px;height:28px;"> 
                <div class="suffix icon-inside clickable" ><i class="icon icon-calendar"></i></div>
          
                <div class="calendar closed">
                  <div class="head">
                    <i class="icon icon-chevron-left"></i>
                    <span class="month"></span>
                    <i class="icon icon-chevron-right"></i>
              
                    <i class="icon icon-chevron-left"></i>
                    <span class="year"></span>
                    <i class="icon icon-chevron-right"></i>
                  </div>
                  <table class="body" >
                    <!-- the body of the calendar is dynamically generated -->
                  </table>
                </div>
          
                <input type="hidden" name="selectedDay" value="">
              </div>
            </span>
            <span class="item"><h4 class="elabel">To</h4></span>
            <span class="item light">
              <div class="datepickerTo">
                <input type="text" placeholder="YYYY-MM-DD" name="datepicker" class="with-icon" style="width:200px;height:28px;">
                <div class="suffix icon-inside clickable"><i class="icon icon-calendar"></i></div>
                <div class="calendar closed">
                  <div class="head">
                    <i class="icon icon-chevron-left"></i>
                    <span class="month"></span>
                    <i class="icon icon-chevron-right"></i>
              
                    <i class="icon icon-chevron-left"></i>
                    <span class="year"></span>
                    <i class="icon icon-chevron-right"></i>
                  </div>
                  <table class="body" >
                    <!-- the body of the calendar is dynamically generated -->
                  </table>
                </div>
                
                <input type="hidden" name="selectedDay" value="">
              </div>
          </span>
          <div style="text-align: right;margin-top:20px;margin-right:20px;"><button class="btn" (click)="getSpecificDates()">Apply</button></div>
        </div>
        <hr style="margin-top: 20px;">
        <div style="justify-content: space-between;margin:20px auto;">
          <div class="elabel" style="display: inline-block">{{'Project Selection' | translate}}</div>
          <div class="elabel" style="float: right;cursor: pointer;" (click)="clearOthers()">{{'Clear' | translate}} <i class="icon icon-restore" style="font-size: 16px;"></i></div>
        </div>
        <div #tree class="tree" style="overflow-y: scroll;scrollbar-width: thin;" *ngIf="isTimeperiedSelected?'tree-enabled':'tree-disabled'" >
        <ul [dir]="textDir"> 
          <li>
            <span class="title item" (click)="getAllCountry('All Country', $event)">{{'All Countries' | translate}}({{countryListData?.length}})</span>
            <ul *ngFor="let item of countryListData | unique: 'name' ; let i=index" [attr.data-index]="i" [dir]="textDir">
              <li><a class="item" (click)="getSelectedCountry(item, $event)">{{item?.name}}</a></li>
            </ul>
          </li>
          <li>
            <span class="title item" (click)="getAllProject('All Project', $event)">{{'All Projects' | translate}}({{projectListData?.length}})</span>
            <ul *ngFor="let item of projectListData; let j=index" [attr.data-index]="j" [dir]="textDir">
              <li><a class="item" (click)="getSelectedProject(item, $event)">{{item?.name}}</a></li>
            </ul>
          </li>

          <li>
            <span class="title item" [ngClass]="schoolListData?.length==0?'opac-5':''" (click)="getAllSchool('All School', $event)">{{'All Schools' | translate}}({{schoolListData?.length}})</span>
            <ul *ngFor="let item of schoolListData; let j=index" [attr.data-index]="j" [dir]="textDir">
              <li><a class="item"  (click)="getSelectedSchool(item, $event)">{{item?.name}}</a></li>
            
            </ul>
          </li>

          <li>
            <span class="title item"  [ngClass]="gradesListData?.length==0?'opac-5':''" (click)="getAllGrade('All Grade', $event)">{{'All Grades' | translate}}</span>
            <ul *ngFor='let item of gradesListData; let i=index' [attr.data-index]="i" [dir]="textDir">
              <li><a class="item" (click)="getSelectedGrade(item, $event)">{{item?.name}}</a></li>
            </ul>
          </li>

          <li>
            <span class="title item" [ngClass]="classesListData?.length==0?'opac-5':''" (click)="getAllClass('All Class', $event)">{{'All Classes' | translate}}</span>
            <ul *ngFor='let item of classesListData; let i=index' [attr.data-index]="i" [dir]="textDir">
              <li><a class="item" (click)="getSelectedClass(item, $event)">{{item?.name}}</a></li>
            </ul>
          </li>
        </ul>
      </div>

      <hr>
      <div style="justify-content: space-between;margin:20px auto;">
        <div class="elabel" style="display: inline-block">{{'User Selection' | translate}}</div>
        <div class="elabel" style="display: inline-block;float:right;cursor: pointer;" (click)="clearUserSection()">{{'Clear' | translate}} <i class="icon icon-restore" style="font-size: 16px;"></i></div>
      </div>
      <div #usertree class="tree" *ngIf="isTimeperiedSelected?'tree-enabled':'tree-disabled'">
        <ul [dir]="textDir">
          <li>
            <span class="title item">{{'All User Types' | translate}}({{teacherCount+studentCount+adminCount}})</span>
            <ul *ngFor="let item of userTypeListData | unique:'role.name'; let i=index" [attr.data-index]="i" [dir]="textDir"> 

              <li *ngIf="item?.role?.name=='Teacher'"><a class="item" (click)="getselectedRole(item, $event)">{{item?.role?.name | translate}}({{teacherCount}})</a></li>
              <li *ngIf="item?.role?.name=='Student'"><a class="item" (click)="getselectedRole(item, $event)">{{item?.role?.name | translate}}({{studentCount}})</a></li>
              <li *ngIf="item?.role?.name=='ProjectAdmin'"><a class="item" (click)="getselectedRole(item, $event)">{{item?.role?.name | translate}}({{adminCount}})</a></li>
             
            </ul>
          </li>
          <li>
            <span class="title item">{{'Genders' | translate}} ({{femaleCount+maleCount}})</span>
            <ul *ngFor="let item of genderListData ; let i=index" [attr.data-index]="i" [dir]="textDir">
              <li *ngIf="item.name=='female'"><a class="item"  (click)="getSelectedGender(item, $event)">{{item.name.charAt(0).toUpperCase() + item.name.slice(1) | translate}}{{' Only'}} ({{femaleCount}})</a></li>
              <li *ngIf="item.name=='male'"><a class="item"  (click)="getSelectedGender(item, $event)">{{item.name.charAt(0).toUpperCase() + item.name.slice(1) | translate}}{{' Only'}} ({{maleCount}})</a></li>
            
            </ul>
          </li>
        </ul>        
      </div>
    <hr>
        </div>
      </div>
      <div class="appcontent" style="margin-left: 10px;scrollbar-width: thin;" >   
        <!-- Row 1 -->
        <div class="row">
          <div style="width:98%">
            <div #tabs class="tabs" style="padding-top: 20px;">
              <div class="titles">
                <div class="title" [ngClass]="{'selected': currentTab === 'overview'}" (click)="gotoTab('overview')">{{'Overview' | translate}}</div>
                <div class="title" [ngClass]="{'selected': currentTab === 'users'}" (click)="gotoTab('users')">{{'Users' | translate}}</div>
                <div class="title" [ngClass]="{'selected': currentTab === 'devices'}" (click)="gotoTab('devices')">{{'Devices' | translate}}</div>
                <div class="title" [ngClass]="{'selected': currentTab === 'applications'}" (click)="gotoTab('applications')">{{'Applications' | translate}}</div>
                <div class="title" [ngClass]="{'selected': currentTab === 'content'}" (click)="gotoTab('content')">{{'Content' | translate}}</div>
                <div  style="opacity: 0.6;margin-top: 5px;cursor: pointer;" [ngClass]="textDir=='rtl'?'pull-left':'pull-right'" (click)="exportData(currentTab)">{{'Export dataset' | translate}} <span style="margin-left: 5px;margin-top: 5px;"><i class="icon icon-document" ></i></span></div>
              </div>            
              <div class="contents" >
                <div class="content" [ngClass]="{'selected': currentTab === 'overview'}">
                  <app-data-overview-component [dataFiltered]="this.selectedTimePeriodStr"></app-data-overview-component>
                </div>
            
                <div class="content" [ngClass]="{'selected': currentTab === 'users'}">                  
                  <app-data-users-component [dataFiltered]="this.selectedTimePeriodStr"></app-data-users-component>  
                </div>
            
                <div class="content" [ngClass]="{'selected': currentTab === 'devices'}">                 
                  <app-data-devices-component [dataFiltered]="this.selectedTimePeriodStr"></app-data-devices-component> 
                </div>

                <div class="content" [ngClass]="{'selected': currentTab === 'applications'}">                  
                  <app-data-applications-component [dataFiltered]="this.selectedTimePeriodStr"></app-data-applications-component>  
                </div>

                <div class="content" [ngClass]="{'selected': currentTab === 'content'}">                
                  <app-data-content-component [dataFiltered]="this.selectedTimePeriodStr"></app-data-content-component>
                </div>          
              </div>
            </div>
          </div>
        </div>	
      </div>
    </div>
  </div>
</main>
